import { FormattedMessage } from 'react-intl';
import React from 'react';

import { Button, Grid } from '@zapier/design-system';

import ServiceIcon from 'app/developer-v3/components/ServiceIcon';

type Props = {
  connectAccount: () => void;
  logoUrl: string;
  serviceName?: string;
};

const AuthButton = ({ connectAccount, logoUrl, serviceName }: Props) => {
  return (
    <Grid
      alignItems="center"
      columns="repeat(2, minmax(0, max-content))"
      gap="8px"
    >
      <ServiceIcon
        serviceName={serviceName}
        size={60}
        src={logoUrl || undefined}
      />
      <Button onPress={connectAccount} variant="tertiary">
        <span>
          <FormattedMessage
            defaultMessage="Connect to {serviceName}"
            id="buttons-connect-to-service"
            values={{ serviceName }}
          />
        </span>
      </Button>
    </Grid>
  );
};

export default AuthButton;
